<template>
  <div>
    <vs-table :data="filteredList">
      <template slot="header">
        <vs-row>
          <vs-col vs-xs="12" vs-sm="2" vs-lg="1" class="px-2">
            <AddPayday
              :clients="clients"
              :days="days"
              :vendorId="vendorId"
               class="mt-4"
              @success="getPaydays()"
            />
          </vs-col>

          <vs-col vs-xs="12" vs-sm="10" vs-lg="11" style="display: inline-flex">
          <div class="con-input-search vs-table--search">
            <input
              class="input-search vs-table--search-input mt-1"
              type="text"
              v-model="search"
            />
            <vs-icon icon="search"></vs-icon>
          </div>
        </vs-col>
        </vs-row>
      </template>
      <template slot="thead">
        <th>{{ $t('client') | capitalize }}</th>
        <th>{{ $t('payday') | capitalize }}</th>
        <th style="text-align: end">{{ $t('actions') | capitalize }}</th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="i" v-for="(tr, i) in data">
          <vs-td>
            {{ data[i].ClientName }}
          </vs-td>
          <vs-td>
            <edit-column-select
              :value="data[i].days"
              :items="days"
              :keys="{ value: 'value', label: 'label' }"
              @update="updatePayday($event, data[i].id)"
               v-if="hasPermission(['IU VENDORS EDIT'])"
            />
            <span v-else>
              {{ data[i].days }}
            </span>
          </vs-td>
          <vs-td style="float: right">
            <action-icon
              icon="TrashIcon"
              :tooltip="$t('delete')"
               v-if="hasPermission(['IU VENDORS EDIT'])"
              @click="confirmDelete(data[i].id)"
            />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import vSelect from 'vue-select'
import request from '../request'
import VendorAccountSidebar from './VendorAccountSidebar.vue'
import AddPayday from './AddPayday.vue'
import EditColumnSelect from '@/views/components/table/EditColumnSelect'
import EditColumnInput from '@/views/components/table/EditColumnInput'
import { PAYDAYS } from '@/const'
import loading from '@/mixins/Loading'

export default {
  props: ['vendorId'],
  mixins: [loading],
  components: {
    ActionIcon,
    EditColumnSelect,
    EditColumnInput,
    'v-select': vSelect,
    VendorAccountSidebar,
    AddPayday,
  },
  data() {
    return {
      search:'',
      clients: [],
      paydays: [],
      days: [],
      loading: {
        clients: false,
        paydays: false,
        submit: false,
      },
      paydayId: '',
    }
  },
  computed: {
    isLoading() {
      return this.loading.clients || this.loading.paydays || this.loading.submit
    },
    filteredList() {
      return this.paydays.filter(item => {
        return item.ClientName.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  methods: {
    getClients() {
      this.loading.clients = true
      request
        .getClients()
        .then((response) => {
          this.clients = response.data.clients
          this.loading.clients = false
        })
        .catch((response) => {
          this.loading.clients = false
          this.showValidationErrors(response)
        })
    },
    getPaydays() {
      this.loading.paydays = true
      request
        .getPaydays(this.vendorId)
        .then((response) => {
          this.paydays = [...response.data.paydays]
          this.loading.paydays = false
        })
        .catch((response) => {
          this.loading.paydays = false
          this.showValidationErrors(response)
        })
    },
    updatePayday(value, id) {
      const payload = {
        payday: value,
      }
      this.loading.submit = true
      request
        .updatePayday(id, payload)
        .then((response) => {
          this.loading.submit = false
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Payday Updated',
          })
          this.getPaydays()
        })
        .catch((response) => {
          this.loading.submit = false
          this.showValidationErrors(response)
          
        })
    },
    confirmDelete(id) {
      this.paydayId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].confirm,
        text: this.$i18n.messages[this.$i18n.locale].confirm_message,
        acceptText: this.$i18n.messages[this.$i18n.locale].delete,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
        accept: this.deletePayday,
      })
    },
    deletePayday() {
      this.loading.submit = true
      request
        .deletePayday(this.paydayId)
        .then((response) => {
          this.loading.submit = false
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Payday Deleted',
          })
          this.getPaydays()
        })
        .catch((response) => {
          this.loading.submit = false
          this.showValidationErrors(response)
        })
    },
  },
  mounted() {
    this.days = PAYDAYS
    this.getClients()
    this.getPaydays()
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('vendor-details-loading')
      } else {
        this.closeLoading('vendor-details-loading')
      }
    },
  },
}
</script>

<style>
.vs-table--not-data {
  display: none !important;
}
</style>